/**
 * ค่าจาก build-time env — credential ของ broker อยู่ใน bundle เสมอเมื่อ HTML
 * ต่อ wss เอง ซึ่งซ่อนไม่ได้ ยอมรับความเสี่ยงนี้แล้วไปคุมสิทธิ์ที่ broker แทน
 * (ARCHITECTURE.md §5.1)
 */
export const ENV = {
  mqttUrl: import.meta.env.VITE_MQTT_URL ?? "wss://mqtt2.rockinevent.com/mqtt",
  mqttUser: import.meta.env.VITE_MQTT_USER ?? "",
  mqttPass: import.meta.env.VITE_MQTT_PASS ?? "",
  apiBase: import.meta.env.VITE_API_BASE ?? "",
  mobileBase: import.meta.env.VITE_MOBILE_BASE ?? "",
  build: import.meta.env.VITE_BUILD ?? "dev",
} as const;
